<template>
  <v-dialog v-model="dialog" max-width="800px">
    <v-card>
      <v-card-title class="mx-3">
        <span
          v-if="value"
          class="red--text d-inline-block text-truncate"
          style="max-width: 640px"
        >
          {{ value.material_name }}
        </span>
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false"
              >fa-times
            </v-icon>
          </template>
          <span>
            {{ $t("$vuetify.close") }}
          </span>
        </v-tooltip>
      </v-card-title>
      <v-divider />
      <v-img
        v-if="value"
        :src="value.img"
        @click.stop="$showFullscreenImages([value.img])"
      ></v-img>
      <v-card-text>
        <v-container v-if="value">
          <v-row align="center" dense>
            <v-col cols="12">
              <v-chip small label dark color="primary" class="me-2">
                {{
                  $t("MaterialOrderRule.mixProductRule.single_max_num") +
                  $t("Global.colon")
                }}
                <span v-if="Number(value.max)">
                  {{ value.max }}
                </span>
                <span v-else>
                  {{ $t("Order.DetailFields.no_limit") }}
                </span>
              </v-chip>
              <v-chip
                v-if="value.check_template"
                small
                label
                dark
                color="primary"
                class="me-2"
              >
                {{ $t("MaterialOrderRule.mixProductRule.usingTemplate") }}
              </v-chip>
            </v-col>
          </v-row>
          <v-divider class="my-2" />
          <v-row align="center" dense>
            <v-col cols="3" class="text-left">
              <span class="font-weight-bold">
                {{
                  $t("MaterialOrderRule.mixProductRule.group_money") +
                  $t("Global.colon")
                }}
              </span>
              {{ $t("Global.money") }} {{ value.price | formatMoney }}
            </v-col>
          </v-row>
          <v-data-table
            :headers="materialHeaders"
            :items="materialItems"
            dense
            multi-sort
            disable-pagination
            hide-default-footer
            fixed-header
          >
            <template v-slot:item.Description="{ item }">
              <a
                class="text-no-wrap"
                @click.stop="$emit('dialogMaterialID', item.id)"
              >
                <span>
                  {{
                    $t(settings
                        ? settings.material_name_display_type == 1
                            ? "Material.materialName"
                            : settings.material_name_display_type == 4
                                ? "Material.nameWithCode"
                            : "Material.materialNameWithCode"
                        : "Material.materialName", [item.material_code, item.material_name])
                  }}
                </span>
                <br />
                <span class="caption secondary--text">
                  {{ $t("Material.Fields.standard") }}{{ $t("Global.colon")}}
                  <span v-if="item.standard_name && item.standard_name.length > 12" :title="item.standard_name" style="cursor: pointer">
                    {{ item.standard_name.slice(0, 12) + "......" }}
                  </span>
                  <span v-else>
                    {{ item.standard_name }}
                  </span>
                </span>
              </a>
            </template>
          </v-data-table>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import i18n from "@/i18n";
import { mapState } from "vuex";

export default {
  name: "CombineMaterialDialog",

  props: { value: Object },

  computed: {
    materialHeaders() {
      return [
        {
          text: i18n.t("MaterialOrderRule.Fields.material_name"),
          align: "start",
          sortable: false,
          value: "Description",
        },
        {
          text: i18n.t("MaterialOrderRule.Fields.num"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "combine_num",
        },
        {
          text: i18n.t("MaterialOrderRule.Fields.price"),
          align: "start",
          sortable: false,
          class: "text-no-wrap",
          value: "combine_price",
        },
      ];
    },
    materialItems() {
      return this.value.details
      //     .map((detail) => {
      //   detail.Description = i18n.t(
      //     this.settings
      //       ? this.settings.material_name_display_type == 3
      //         ? "Material.materialNameWithCodeAndStandard"
      //         : this.settings.material_name_display_type == 2
      //         ? "Material.materialNameWithCode"
      //         : "Material.materialName"
      //       : "Material.materialName",
      //     [detail.material_code, detail.material_name, detail.standard_name]
      //   );
      //   return detail;
      // });
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },

  data: () => ({
    dialog: false,
  }),

  watch: {
    dialog: {
      handler() {
        if (!this.dialog) this.$emit("input", null);
      },
    },
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        if (this.value) {
          this.dialog = true;
          // console.log(this.value);
        }
      },
    },
  },
};
</script>